<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="row">
          <div
            class="top-0 my-auto text-center col-8 d-lg-flex d-none pe-0 justify-content-center flex-column"
            style="height: 100vh"
          >
            <div
              class="position-relative bg-gradient-primary h-100 px-7 d-flex flex-column justify-content-center overflow-hidden"
              :style="{
                backgroundImage:
                  'url(' + require('@/assets/img/sign-in-side-image.jpg') + ')',
                backgroundSize: 'cover',
              }"
            >
              <span class="mask bg-gradient-secondary opacity-4"></span>
              <h4 class="mt-5 text-white font-weight-bolder position-relative">
                "Here to Simplify Your Hospital’s Management, One Click at a
                Time"
              </h4>
              <p class="text-white position-relative">
                A hospital and clinic management software which enables you to
                run your core financial, clinical, and operational processes
              </p>
            </div>
          </div>
          <div
            class="col-xl-4 col-lg-4 col-md-4 d-flex flex-column mx-lg-0 my-auto align-items-end"
          >
            <div class="card card-plain">
              <div class="pb-0 card-header text-start">
                <h4 class="font-weight-bolder">Sign In</h4>
                <p class="mb-1">Enter your email and password to sign in</p>

                <p class="mx-auto mb-0 text-sm">
                  Don't have an account?
                  <router-link
                    to="/signup"
                    class="text-success text-gradient font-weight-bold"
                    >Sign up</router-link
                  >
                </p>
              </div>
              <div class="card-body">
                <el-form
                  ref="loginFormRef"
                  :model="loginForm"
                  :rules="rules"
                  label-width="auto"
                  class="demo-ruleForm"
                  size="large"
                  status-icon
                  :scroll-to-error="true"
                  label-position="top"
                  :hide-required-asterisk="true"
                >
                  <el-form-item label="Email" prop="username">
                    <el-input type="email" v-model="loginForm.username" />
                  </el-form-item>
                  <el-form-item label="Password" prop="password">
                    <el-input
                      v-model="loginForm.password"
                      type="password"
                      :show-password="true"
                    />
                  </el-form-item>

                  <el-button
                    type="success"
                    class="px-5 d-block my-3 mx-auto"
                    :loading="isLoading"
                    @click="submitForm(loginFormRef)"
                  >
                    Login
                  </el-button>
                </el-form>
              </div>
              <div class="px-1 pt-0 text-center card-footer px-lg-2">
                <p class="mx-auto mb-4 text-sm">
                  Forgot your password?
                  <router-link
                    to="/forgot-password"
                    class="text-success text-gradient font-weight-bold"
                    >Reset</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { reactive, ref } from "vue";
import { ElNotification, ElMessage } from "element-plus";
import { login } from "../api/services/authentication";
import { useRouter } from "vue-router";
import { h } from "vue";

const body = document.getElementsByTagName("body")[0];
const loginFormRef = ref();
const isLoading = ref(false);

export default {
  setup() {
    const router = useRouter();
    const loginForm = reactive({
      username: "",
      password: "",
    });

    const rules = reactive({
      username: [
        {
          required: true,
          message: "Please input email address",
          trigger: "blur",
        },
        {
          type: "email",
          message: "Please input correct email address",
          trigger: ["blur", "change"],
        },
      ],
      password: [
        {
          required: true,
          message: "Please input your password",
          trigger: ["blur", "change"],
        },

        {
          min: 6,
          max: 255,
          message: "Minimum characters should be 6",
          trigger: "blur",
        },
      ],
    });

    const submitForm = async (formEl) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          isLoading.value = true;

          let body = {
            grant_type: "password",
            client_id: process.env.VUE_APP_PASSWORD_API_KEY,
            client_secret: process.env.VUE_APP_PASSWORD_API_SECRET,
            username: loginForm.username,
            password: loginForm.password,
          };

          login(body)
            .then((response) => {
              if (response.status == 200) {
                localStorage.setItem("isAuthenticated", true);
                localStorage.setItem("token", response.data.access_token);
                localStorage.setItem(
                  "user",
                  JSON.stringify(response.data.user)
                );
                localStorage.setItem(
                  "organizations",
                  JSON.stringify(response.data.organizations)
                );
                localStorage.setItem(
                  "organization",
                  JSON.stringify(response.data.organizations[0])
                );
                localStorage.setItem(
                  "permissionlist",
                  JSON.stringify(response.data.permissions)
                );
                localStorage.setItem(
                  "permissions",
                  JSON.stringify(
                    response.data.permissions[response.data.organizations[0].id]
                  )
                );
                localStorage.setItem(
                  "role",
                  response.data.roles[response.data.organizations[0].id]
                );
                localStorage.setItem(
                  "roles",
                  JSON.stringify(response.data.roles)
                );
                localStorage.setItem(
                  "profileName",
                  response.data.user.first_name +
                    " " +
                    response.data.user.last_name
                );

                router.replace({ path: "/dashboard" });
                ElMessage({
                  message: h(
                    "i",
                    { style: "color: teal" },
                    `Welcome ${
                      response.data.user.first_name +
                      " " +
                      response.data.user.last_name
                    } to your dashboard`
                  ),
                  type: "success",
                });
              } else if (response.status == 401) {
                ElNotification({
                  title: "Error",
                  message:
                    "Invalid login credentials. Please confirm login details and try again.",
                  type: "error",
                });
              } else {
                console.log(response);
                ElNotification({
                  title: "Error",
                  message: response.data.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
              ElNotification({
                title: "Error",
                message: err.message,
                type: "error",
              });
            })
            .finally(() => {
              isLoading.value = false;
            });
        } else {
          console.log("error submit!", fields);
        }
      });
    };

    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };

    return {
      isLoading,
      resetForm,
      submitForm,
      rules,
      loginForm,
      loginFormRef,
    };
  },

  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
<style scoped>
.el-button .custom-loading .circular {
  margin-right: 6px;
  width: 18px;
  height: 18px;
  animation: loading-rotate 2s linear infinite;
}
</style>
